import merge from 'lodash.merge';
import baseOptions from './baseOptions';

const mergeWithBaseOptions = (...args) => merge({}, baseOptions, ...args);

export default mergeWithBaseOptions;
